import DefaultValidation from '@/services/validations/DefaultValidation';
import * as Util from '@/functions/Util';

export default class GrupoEconomicoValidation extends DefaultValidation {
	validate(model, refs) {
		let validated = true;

		Object.entries(model).forEach(([key, value]) => {
			if(value!=null && typeof value == "string") model[key] = value.trim();
		});
        
        if (Util.isNull(model.idgrupoeconomicoerp)) {
			refs.idErpInput.focusedOut = true;
			validated = false;
		}

		if (Util.isNull(model.descricao)) {
			refs.descricaoInput.focusedOut = true;
			validated = false;
		}

        if (Util.isNull(model.idgrupoeconomicoerp)) {
			refs.idErpInput.focusedOut = true;
			validated = false;
		}

        return validated;
    }
}
